<template>
    <div class="flex items-center">
        <inertia-link
            class="w-full p-4"
            v-if="redirectUrl && numericValue > 0"
            :href="redirectUrl"
        >
            <p
                class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
                {{ capitalize(name) }}
            </p>
            <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {{ value
                }}{{
                    type === "student" && name !== "review"
                        ? "%"
                        : name === "present" || name === "absent"
                        ? "%"
                        : ""
                }}
            </p>
        </inertia-link>
        <div v-else class="p-4">
            <p
                class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
                {{ capitalize(name) }}
            </p>
            <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {{ value
                }}{{
                    type === "student" && name !== "review"
                        ? "%"
                        : name === "present" || name === "absent"
                        ? "%"
                        : ""
                }}
            </p>
        </div>
    </div>
</template>
<script setup>
import { capitalize } from "@vue/shared";
import { computed } from "vue";

const props = defineProps({
    name: {
        type: [Number, String],
    },
    value: {
        type: [Number, String],
    },
    admission: {
        type: Object,
    },
    branchId: {
        type: [Number, String],
    },
    type: {
        type: String,
        default: "student",
    },
});

const numericValue = computed(() => {
    if (props.name === "review") {
        if (typeof props.value === "string") {
            const match = props.value.match(/^(\d+(\.\d+)?)/);
            return match ? parseFloat(match[1]) : Number(props.value);
        }
    }
    return typeof props.value === "string" ? Number(props.value) : props.value;
});

const redirectUrl = computed(() => {
    if (props.type === "student") {
        switch (props.name) {
            case "presentation":
                return route(`internal.admission.view.presentation`, [
                    props.branchId,
                    props.admission?.id,
                ]);
            case "bonus":
                return route(`internal.admission.view.bonus`, [
                    props.branchId,
                    props.admission?.id,
                ]);
            case "assignment":
                return route(`internal.admission.view.assignment`, [
                    props.branchId,
                    props.admission?.id,
                ]);
            case "viva":
                return route(`internal.admission.view.viva`, [
                    props.branchId,
                    props.admission?.id,
                ]);
            case "review":
                return route(`internal.admission.view.review`, [
                    props.branchId,
                    props.admission?.id,
                ]);
        }
    } else {
        switch (props.name) {
            case "presentation":
                return route(`administrative.faculty.view.presentation`, [
                    props.admission?.id,
                    props.branchId,
                ]);
            case "bonus":
                return route(`administrative.faculty.view.bonus`, [
                    props.admission?.id,
                    props.branchId,
                ]);
            case "assignment":
                return route(`administrative.faculty.view.assignment`, [
                    props.admission?.id,
                    props.branchId,
                ]);
            case "viva":
                return route(`administrative.faculty.view.viva`, [
                    props.admission?.id,
                    props.branchId,
                ]);
            case "review":
                return route(`administrative.faculty.view.review`, [
                    props.admission?.id,
                    props.branchId,
                ]);
        }
    }

    return null;
});
</script>
